import React from "react";
import CookieConsent from "react-cookie-consent";

export default function Cookie() {
  return (
    <CookieConsent
      overlay
      location="bottom"
      cookieName="myAppCookieConsent"
      enableDeclineButton
      buttonText="Aceptar todas"
      declineButtonText="Rechazar"
      containerClasses="w-full px-4 py-4 fixed bg-white shadow-md flex flex-col md:flex-row items-center justify-between gap-4 z-50 border-t"
      contentClasses="text-sm text-gray-800 max-w-xl"
      style={{
        background: "linear-gradient(#ED7850, #051432)",
      }}
      buttonStyle={{
        background: "#051432",
        color: "white",

        borderRadius: "0.375rem",
      }}
      declineButtonStyle={{
        background: "gray",
        color: "white",

        borderRadius: "0.375rem",
      }}
      expires={365}
    >
      <div className="">
        <p className="text-sidom-light">
          We use cookies to help you navigate efficiently and perform certain
          functions. You will find detailed information about all cookies under
          each consent category below. The cookies that are categorized as
          "Necessary" are stored on your browser as they are essential for
          enabling the basic functionalities of the site. We also use
          third-party cookies that help us analyze how you use this website,
          store your preferences, and provide the content and advertisements
          that are relevant to you. These cookies will only be stored in your
          browser with your prior consent. You can choose to enable or disable
          some or all of these cookies but disabling some of them may affect
          your browsing experience.
        </p>
      </div>
    </CookieConsent>
  );
}
